import { Component, OnInit } from '@angular/core';
import { loginModel } from '../http-post-request-object-classes/loginModel';
import { uploadModel } from '../http-post-request-object-classes/uploadModel';
import { WorkspaceService } from '../../workspace.service'
import * as moment from 'moment';
import { Router } from "@angular/router";
import { registerModel } from '../http-post-request-object-classes/registerModel';
import {resetPasswordSendMailModel} from '../http-post-request-object-classes/resetPasswordSendMailModel'

@Component({
  selector: 'login-form',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class loginComponent implements OnInit {
  noticeAgreed = false;

  showProgressBar = false;
  isLogedIn = false;
  condition = true;
  progressValue = '30';

  selectedMoment = new Date();
  message = '';
  errorMessage = '';
  successFlag: boolean = false;
  errorFlag: boolean = false;
  utcformat = this.selectedMoment.toUTCString();
  formatDate = moment(this.utcformat).format('YYYY-MM-DD HH:mm:ss');
  types = ['VALUE', 'STANDARD', 'PERFORMANCE', 'POWER', 'GRAPHICS'];
  model = new loginModel('', '');

  showAlertMessage = false;
  showAlertMessageBody = '';

  loginEmailError = false;
  loginEmailErrorMessage = '';
  loginEmailOk = false;

  loginEmail = '';
  loginPassword = '';

  loginPasswordError = false;
  loginPasswordErrorMessage = '';

  signupEmail = '';
  signupPassword = '';
  signupUsername = '';

  signupEmailError = false;
  signupEmailErrorMessage = '';
  signupEmailOk = false;


  signupPasswordError = false;
  signupPasswordErrorMessage = '';
  signupPasswordOk = false;

  signupUsernameError = false;
  signupUsernameErrorMessage = '';
  signupUsernameOk = false;

  emailOk = false;

  loginModel = new loginModel('', '');
  registerModel = new registerModel('', '', '');
  showLoading = false;
  showSignupLoading = false;

  showRegistrationSuccessMessage = false;
  registrationSuccessMessage = '';
  showRegisterServerError = false;
  registerServerErrorMessage = '';
  showRegistrationValidationError = false;
  validationErrorMessage = '';
  showLoginServerError = false;

  showLoginError = false;
  showLoginSuccess = false;
  loginSuccessMessage = '';
  loginErrorMessage = '';

  termsModalOpen = false;

  theme = '';
  // Forgot password variables
  didntForgotPassword = true;
  forgotPasswordMailError = false;
  forgotPasswordMailErrorMessage = '';
  resetPasswordSendMailModel = new resetPasswordSendMailModel('');
  requestPasswordResetMail = '' as any;
  passwordResetConfirmationModalShow = false;
  passwordResetModalMessage = '';
  passwordResetModalType = '';
  passwordResetModalSpinnerShow = false;
  constructor(public dataService: WorkspaceService, private router: Router) {

  }

  register() {
    this.showSignupLoading = true;
    let self = this;
    setTimeout(() => {
      if (this.signupEmailOk && this.signupUsernameOk && this.signupPasswordOk) {
        let signupUsernameInput = document.getElementById('signup-username') as HTMLInputElement;
        this.registerModel.mail = this.signupEmail;
        this.registerModel.username = signupUsernameInput.value;
        this.registerModel.passw = this.signupPassword;
        this.dataService.register(this.registerModel)
          .subscribe(data => {
            let receivedData = data as any;
            //console.log(data);
            self.showSignupLoading = true;
            self.showRegisterServerError = false;
            self.showRegistrationValidationError = false;
            self.showRegistrationSuccessMessage = true;
            self.registrationSuccessMessage = "Registration success !!! Navigating to your home page";
            this.dataService.routeMemory = 'home';
            this.dataService.loginData.uid = receivedData.user.id;
            this.dataService.loginData.uname = receivedData.user.username;
            this.dataService.loginData.umail = receivedData.user.mail;
            this.dataService.loginData.orders = receivedData.user.orders;
            this.dataService.loginData.passw = this.signupPassword;
            this.dataService.loginAuthorized = true;
            
            setTimeout(() => {
              this.router.navigateByUrl('/home');
            }, 200)

          },
            error => {
              //console.log(error)
              self.showSignupLoading = false;
              self.showRegisterServerError = true;
              self.showRegistrationValidationError = false;
              self.showRegistrationSuccessMessage = false;
              self.registerServerErrorMessage = 'Invalid Credentials.'
              if (error.status == 400) {
                self.registerServerErrorMessage = self.registerServerErrorMessage + " (Seems like you already have an account associated with this mail) !!!";
              }
            })
      }
      else {
        self.showSignupLoading = false;
        self.showRegistrationValidationError = true
        self.validationErrorMessage = 'The details entered are not in the specified format.'
      }
    }, 200)
  }

  login() {
    this.showLoading = true;
    setTimeout(() => {
      if (this.loginEmailOk && (this.loginPassword !== '')) {
        this.loginEmailError = false;
        this.loginEmailErrorMessage = ""
        this.loginPasswordError = false;
        this.loginPasswordErrorMessage = '';
        this.loginModel.mail = this.loginEmail;
        this.loginModel.passw = this.loginPassword;
        //console.log(this.loginModel)
        this.dataService.login(this.loginModel)
          .subscribe(data => {
            let receivedData = data as any;
            //console.log(data);
            this.showLoginError = false;
            this.showLoginSuccess = true;
            this.loginSuccessMessage = "Login Success !!! Navigating to your home page";
            this.showLoading = true;
            this.dataService.routeMemory = 'home';
            this.dataService.loginData.uid = receivedData.user.id;
            this.dataService.loginData.uname = receivedData.user.username;
            this.dataService.loginData.umail = this.loginEmail;
            this.dataService.loginData.orders = receivedData.user.orders;
            this.dataService.loginData.passw = this.loginPassword;
            this.dataService.loginAuthorized = true;
            sessionStorage.setItem('mail',this.loginEmail);
            setTimeout(() => {
              this.router.navigateByUrl('/home');
            }, 200)

          },
            error => {
              //console.log('server error');
              this.showLoading = false;
              this.showLoginServerError = true;
              this.showLoginError = true;
              this.showLoginSuccess = false;
              this.loginErrorMessage = "Invalid Credentials";
              if (error.status === 0) {
                this.loginErrorMessage = "No Internet connection";
              }
              //console.log(error)
            })
      }
      else {
        //console.log('error');
        this.showLoginError = true;
        this.showLoginSuccess = false;
        this.loginErrorMessage = 'Login Credentials are not in correct format'
        this.showLoading = false;
      }
    }, 200)


    //     else {
    //     this.showProgressBar = true;

    //     this.dataService.login(this.model)
    //   .subscribe(data =>
    //      {
    //       this.progressValue = '100' ;
    //       // this.router.navigate(['./delete', this.model.username,this.model.passw]);
    //       if (typeof(Storage) !== "undefined") {
    //         console.log(`Sorry, your browser does not support Web Storage...`);
    //       }
    //       localStorage.clear();
    //       let key = 'p';
    //       let key2 = 'id';
    //       localStorage.setItem(key, this.model.passw);
    //       localStorage.setItem(key2, this.model.username);
    //       this.router.navigate(['./delete']);
    //     },
    //     error => 
    //     {
    //       console.log(`error occured after calling the server login().`);
    //       this.showProgressBar = false;
    //       this.showAlertMessage= false;
    //       this.errorFlag=true;
    //       this.errorMessage='Error while login, please try again !';
    //       this.model = new loginModel(this.model.username,this.model.passw);
    //     }
    //   )
    // }

    // this.router.navigate(['./delete', 25,'ewtryw']);
  };
  activateLinkOnEnter(event) {
    if (event.key === "Enter") {
      event.target.click();
    }
  }
  signup() {
    let login = document.querySelector('.login-layout') as HTMLElement;
    let signup = document.querySelector('.signup-layout') as HTMLElement;

    let loginUsername = document.getElementById('login-user-name') as HTMLInputElement
    let loginButton = document.getElementById('login-login') as HTMLInputElement
    let loginPassword = document.getElementById('login-pwd') as HTMLInputElement
    let loginCancelButton = document.getElementById('login-cancel') as HTMLInputElement
    let signupEmail = document.getElementById('signup-email') as HTMLInputElement
    let signupUsername = document.getElementById('signup-username') as HTMLInputElement
    let signupPassword = document.getElementById('signup-password') as HTMLInputElement
    let signupRegisterButton = document.getElementById('signup-register') as HTMLInputElement
    let signupCancelButton = document.getElementById('signup-back-button') as HTMLInputElement
    signupEmail.disabled = false;
    signupUsername.disabled = false;
    signupPassword.disabled = false;
    signupRegisterButton.disabled = false;
    signupCancelButton.disabled = false;
    signupRegisterButton.tabIndex = 0;
    signupCancelButton.tabIndex = 0;
    this.showLoginSuccess = false;
    this.showLoginError = false;
    login.classList.add('rtl-animation-fade');
    signup.classList.add('rtl-animation-appear');
    setTimeout(function () {
      loginUsername.disabled = true;
      loginPassword.disabled = true;
      loginButton.disabled = true;
      loginCancelButton.disabled = true;
      // signupEmail.disabled=false;
      // signupUsername.disabled=false;
      // signupPassword.disabled=false;
      // signupRegisterButton.disabled=false;
      // signupCancelButton.disabled=false;
      // signupRegisterButton.tabIndex=0;
      // signupCancelButton.tabIndex=0;

    }, 800)


  }
  goBackToLogin() {

    let login = document.querySelector('.login-layout') as HTMLElement;
    let signup = document.querySelector('.signup-layout') as HTMLElement;

    let loginUsername = document.getElementById('login-user-name') as HTMLInputElement
    let loginButton = document.getElementById('login-login') as HTMLInputElement
    let loginPassword = document.getElementById('login-pwd') as HTMLInputElement
    let loginCancelButton = document.getElementById('login-cancel') as HTMLInputElement
    let signupEmail = document.getElementById('signup-email') as HTMLInputElement
    let signupUsername = document.getElementById('signup-username') as HTMLInputElement
    let signupPassword = document.getElementById('signup-password') as HTMLInputElement
    let signupRegisterButton = document.getElementById('signup-register') as HTMLInputElement
    let signupCancelButton = document.getElementById('signup-back-button') as HTMLInputElement
    loginUsername.disabled = false;
    loginButton.disabled = false;
    loginPassword.disabled = false;
    loginCancelButton.disabled = false;
    this.showRegistrationSuccessMessage = false;
    this.showRegisterServerError = false;
    this.showRegistrationValidationError = false;
    login.classList.remove('rtl-animation-fade');
    signup.classList.remove('rtl-animation-appear');
    setTimeout(function () {
      signupUsername.disabled = true;
      signupEmail.disabled = true;
      signupPassword.disabled = true;
      signupRegisterButton.disabled = true;
      signupCancelButton.disabled = true;
      signupRegisterButton.tabIndex = -1;
      signupCancelButton.tabIndex = -1;
      // loginUsername.disabled=false;
      // loginButton.disabled=false;
      // loginPassword.disabled=false;
      // loginCancelButton.disabled=false;
    }, 800)
  }

  validateMail(target) {

    if (target.value == "") {
      this.loginEmailError = false;
      this.loginEmailErrorMessage = '';
      this.signupEmailError = false;
      this.signupEmailErrorMessage = '';
      if (target.id == "login-user-name") {
        this.loginEmailOk = false;
      }
      else {
        this.signupEmailOk = false;
      }
      target.removeAttribute('success');
      return
    }

    this.showAlertMessage = false;
    this.showAlertMessageBody = '';

    // let mailRegX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let mailRegX = /[a-z0-9]+\.?([a-z0-9])*@[a-z0-9]+-*[a-z]*\.[a-z]{3}\;*/
    let contains2parts = false;
    let part1;
    let part2;
    let isValidInput = false;
    // if mail is wrong
    let valueArr = target.value.split(';');
    part1 = valueArr[0];

    if (valueArr.length === 2) {
      part2 = valueArr[1];
      isValidInput = mailRegX.test(part1) && mailRegX.test(part2);
    }
    else if (valueArr.length === 1) {
      isValidInput = mailRegX.test(part1);
    }
    else {
      // do nothing
    }
    if (!isValidInput) {
      if (target.id == "login-user-name") {
        this.loginEmailError = true;
        this.loginEmailErrorMessage = 'email is not correct format';
        this.loginEmailOk = false;
      }
      else {
        this.signupEmailError = true;
        this.signupEmailErrorMessage = 'email is not correct format';
        this.signupEmailOk = false;
        target.removeAttribute('success');
      }
    }
    else {
      if (target.id == "login-user-name") {
        this.loginEmailError = false;
        this.loginEmailErrorMessage = '';
        this.loginEmailOk = true;
        this.loginEmail = target.value;
      }
      else {
        this.signupEmailError = false;
        this.signupEmailErrorMessage = '';
        this.signupEmailOk = true;
        this.signupEmail = target.value;
        target.setAttribute('success', true);
      }
    }
  };
  validateForgotPasswordMail(value) {
    if (!value) {
      this.forgotPasswordMailError = false;
      this.forgotPasswordMailErrorMessage = null;
      this.requestPasswordResetMail = null;
      return;
    }
    let mailRegX = /[a-z0-9]+\.?([a-z0-9])*@[a-z0-9]+-*[a-z]*\.[a-z]{3}\;*/;
    if (mailRegX.test(value)) {
      this.forgotPasswordMailError = false;
      this.forgotPasswordMailErrorMessage = null;
      this.requestPasswordResetMail = value;
    }
    else {
      this.forgotPasswordMailError = true;
      this.forgotPasswordMailErrorMessage = 'Email is not in correct format';
      this.requestPasswordResetMail = null;
    }
  }
  requestPasswordReset() {
    this.passwordResetModalType = ''
    this.passwordResetModalMessage = ``;
    this.passwordResetConfirmationModalShow = true;
    this.passwordResetModalSpinnerShow = true;
    if(!this.requestPasswordResetMail) {
      this.passwordResetModalType = `error`;
      this.passwordResetModalMessage = `Please enter correct email`;
      this.passwordResetModalSpinnerShow = false;
      return;
    }
    this.resetPasswordSendMailModel.mail = this.requestPasswordResetMail;
    this.dataService.forgotPasswordSendMail(this.resetPasswordSendMailModel).
      subscribe(data => {
        console.log(data);
        this.passwordResetModalType = `confirmation`;
        this.passwordResetModalMessage = `We have received your password reset request. Please check your email for further instructions`;
        this.passwordResetModalSpinnerShow = false;
      },
      error => {
        this.passwordResetModalType = `error`;
        if(error.status === 0) {
          this.passwordResetModalMessage = `No internet connection`;
          this.passwordResetModalSpinnerShow = false;
        }
        if(error.status === 401) {
          this.passwordResetModalMessage = `Sorry, but this email is not registered with us. Please use an email that is registered with us`;
        }
        
        this.passwordResetModalSpinnerShow = false;
        console.log(error)
      })
  }
  validatePassword(target, value) {
    if (value === '') {
      this.signupPasswordError = false;
      this.signupPasswordErrorMessage = '';
      this.signupPasswordOk = false;
      target.removeAttribute('success');
      return;
    }

    let pwdRegX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$/;
    if (!pwdRegX.test(value)) {
      this.signupPasswordError = true;
      this.signupPasswordErrorMessage = 'Your password is not in the correct format.It should contain one capital, one small, one special, one numeric and total 6-12 characters. ex: Password@1';
      this.signupPasswordOk = false;
      target.removeAttribute('success');
    }
    else {
      this.signupPasswordError = false;
      this.signupPasswordErrorMessage = '';
      this.signupPasswordOk = true;
      this.signupPassword = value;
      target.setAttribute('success', true);
    }
  }

  validateUsername(event) {
    if (event.target.value === '') {
      this.signupUsernameErrorMessage = '';
      this.signupUsernameError = false;
      this.signupUsernameOk = false;
      event.target.removeAttribute('success');
      return;
    }
    let value = event.target.value;
    let usrNameRegX = /[!$%^&*()_+|~=`\\#{}\[\]:";'<>?\/\s]/g;
    if (value.length <= 4) {
      this.signupUsernameErrorMessage = 'User name must contain minimum five characters.';
      this.signupUsernameError = true;
      this.signupUsernameOk = false;
      event.target.removeAttribute('success');
      return;
    }
    if (usrNameRegX.test(value)) {
      this.signupUsernameErrorMessage = 'User name is not in correct format. Must contain alphanumeric characters or only alphabets.';
      this.signupUsernameError = true;
      this.signupUsernameOk = false;
      event.target.removeAttribute('success');
      return;
    }
    this.signupUsernameErrorMessage = '';
    this.signupUsernameError = false;
    this.signupUsernameOk = true;
    event.target.setAttribute('success', true);
  }

  Cancel() {
    this.showAlertMessage = false;
    this.showAlertMessageBody = '';
    this.message = '';
    this.errorMessage = '';
    this.successFlag = false;
    this.errorFlag = false;
    this.router.navigate(['./login']);
    this.model = new loginModel('', '');
  };


  hideErrorDialog() {
    this.showAlertMessage = false;
    this.showAlertMessageBody = '';
  };
  validateInput(model) {
    this.showAlertMessage = false;
    this.showAlertMessageBody = '';

    let pwdRegX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$/;
    let usrNameRegX = /^\d+$/;
    // let mailRegX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (usrNameRegX.test(model.username)) {
      this.showAlertMessageBody = 'User name is not correct format. Must contain alphanumeric characters or only alphabets.';
      this.showAlertMessage = true;
      return false;
    }
    // else if(!pwdRegX.test(model.passw)) {
    //   this.showAlertMessageBody= 'Your password is not correct format. Should contain one capital, one small, one special, one numeric and total 6-12 charectors. ex: Password@1';
    //   this.showAlertMessage= true;
    //   return false;
    // }

    else {
      return true;
    }
  };
  clickLogin(event) {

    if (event.key === "Enter" || event.keyCode === 13) {
      let loginButton = document.getElementById('login-login') as HTMLInputElement;
      loginButton.click();
    }
  }

  OpenTermsModal() {
    this.termsModalOpen = true;
    let topTermsText = document.getElementById("termsAndConditionsTopText");
    setTimeout(() => {
      topTermsText.scrollIntoView();
    }, 250);
  }

  CloseTermsModal() {
    this.termsModalOpen = false;
  }

  switchTheme(e) {
    const self = this;
    setTimeout(() => {
      if (e.target.id === "themeSwitcherIcon") {
        if (self.theme === "dark") {
          self.dataService.theme = "light";
        }
        else {
          self.dataService.theme = "dark";
        }
      }
      else {
        if (e.target.active) {
          self.dataService.theme = "dark";
        }
        else {
          self.dataService.theme = "light";
        }
      }
      self.theme = self.dataService.theme;
    }, 300);
  }

  showLeftDrawer() {
    let drawer = document.getElementById('drawer-left-login') as any;
    drawer.visible = true;
  }
  resetForgotPasswordDefaults(element) {
    if(element.id === 'goBackToLoginLink') {
      this.didntForgotPassword = true;
    }
    else {
      this.didntForgotPassword = false;
    }
    this.forgotPasswordMailError = false;
    this.forgotPasswordMailErrorMessage = '';
  }
  ngOnInit() {
    let signupEmail = document.getElementById('signup-email') as HTMLInputElement
    let signupUsername = document.getElementById('signup-username') as HTMLInputElement
    let signupPassword = document.getElementById('signup-password') as HTMLInputElement
    let signupRegisterButton = document.getElementById('signup-register') as HTMLInputElement
    let signupCancelButton = document.getElementById('signup-back-button') as HTMLInputElement
    signupUsername.disabled = true;
    signupEmail.disabled = true
    signupPassword.disabled = true
    signupRegisterButton.disabled = true
    signupCancelButton.disabled = true
    signupRegisterButton.tabIndex = -1;
    signupCancelButton.tabIndex = -1;

    /**
     *  Select Theme
     * 
     */
    this.theme = this.dataService.theme;
    const bodyElement = document.body as any;
    bodyElement.style.opacity = 0;
    setTimeout(() => {
      bodyElement.style.opacity = 1;
    }, 3000);


    // let loginButton = document.getElementById('login-login') as HTMLInputElement

    // Automating login just for speed testing
    // setTimeout(() => {
    //   let loginButton = document.getElementById('login-login') as HTMLInputElement 
    //   let loginUsername = document.getElementById('login-user-name') as HTMLInputElement  
    //   let loginPassword = document.getElementById('login-pwd') as HTMLInputElement 
    //   var i=0;
    //   var speed=1;
    //   function typeWrite(el, value) {
    //     if(i < value.length) {
    //       if(i==0) {
    //         el.value = value[0];
    //       }
    //       else{
    //         el.value += value[i];
    //       }        
    //       i++;
    //       setTimeout(typeWrite,speed, el, value);
    //     }
    //     else {
    //       i=0;
    //       return;
    //     }
  
    //   }
    //   typeWrite(loginUsername, 'arun.kayavil@siemens-healthineers.com')
    //   setTimeout(()=>{typeWrite(loginPassword, 'Password@1')},2000)
    //   setTimeout(()=>{loginButton.click()},2500);
    // }, 500);
   
    // loginButton.click();
  }

  noticeAgreedClicked(){
    this.theme='dark';
    this.dataService.theme = 'dark';
      this.noticeAgreed = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-workspace/login/login.component.ts